
define('ldsh!modules/user/item/template', [], function() {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<h1>User</h1>\n<dl>\n  \n\t <dd>\n   <span name="username"></span>\n  </dd>\n  \n\t <dd>\n   <span name="password"></span>\n  </dd>\n\n</dl>';

}
return __p
};});

